module.exports = __webpack_public_path__ + "assets/media/rectangle.08e13105.svg";